const API_BASE =
  process.env.REACT_APP_FUNCTIONS_URL ||
  "https://us-central1-auravit-bb843.cloudfunctions.net";

const ensureDefaultAdminUrl = `${API_BASE}/ensureDefaultAdmin`;
const resetPasswordByEmailUrl = `${API_BASE}/resetPasswordByEmail`;
const updateUserEmailUrl = `${API_BASE}/updateUserEmail`;

export const ADMIN_ACCOUNT_ID = "ADMAURA2026";

export const ensureDefaultAdmin = async () => {
  const response = await fetch(ensureDefaultAdminUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({}),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Failed to ensure default admin account.");
  }

  return data;
};

export const resetPasswordByEmail = async ({ email, password, oobCode }) => {
  const body = { email, password };
  if (oobCode) body.oobCode = oobCode;
  const response = await fetch(resetPasswordByEmailUrl, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

  const data = await response.json().catch(() => ({}));
  if (!response.ok) {
    throw new Error(data.error || "Failed to reset password.");
  }
  return data;
};

export const updateUserEmailByUid = async ({ uid, email, idToken }) => {
  console.log("📡 updateUserEmailByUid called:", { uid, email, url: updateUserEmailUrl });
  
  try {
    const response = await fetch(updateUserEmailUrl, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${idToken}`,
      },
      body: JSON.stringify({ uid, email }),
    });

    console.log("📡 Response status:", response.status, response.statusText);

    const data = await response.json().catch(() => {
      console.error("❌ Failed to parse response as JSON");
      return {};
    });
    
    console.log("📡 Response data:", data);

    if (!response.ok) {
      throw new Error(data.error || `Failed to update user email. Status: ${response.status}`);
    }
    
    console.log("✅ Email update successful");
    return data;
  } catch (error) {
    console.error("❌ updateUserEmailByUid fetch error:", error);
    console.error("Error details:", {
      message: error.message,
      name: error.name,
      url: updateUserEmailUrl,
      isNetworkError: error.message === "Failed to fetch"
    });
    throw error;
  }
};
